import { WishlistItem as AdvoxWishlistItem } from 'AdvoxComponent/WishlistItem/WishlistItem.component';
import DiscountLabel from 'Component/DiscountLabel/DiscountLabel.component';
import Icons from 'Component/Icons';
import Label from 'Component/Label';
import ProductCardWishlist from 'Component/ProductCardWishlist';
import { roundPercentage } from 'Util/Percentage/Percentage';
import { getPrice } from 'Util/Product/Extract';

import './WishlistItem.override.style';

/** @namespace Pwa/Component/WishlistItem/Component */
export class WishlistItem extends AdvoxWishlistItem {
    renderRemove() {
        const { removeItem } = this.props;

        return (
            <button block="WishlistItem" elem="Remove" onClick={removeItem} aria-label={__('Remove')}>
                <Icons name="trash" fill="#E7E7E7" width="16px" height="27px" />
            </button>
        );
    }

    renderPrice(productPrice) {
        const { inStock } = this.props;

        if (!inStock) {
            return null;
        }

        return (
            <div block="WishlistItem" elem="Price">
                {productPrice()}
            </div>
        );
    }

    renderLabels() {
        const {
            product: { labels },
        } = this.props;

        return labels && labels.map((label, index) => <Label {...label} key={`label${index}`} />);
    }

    renderDiscountLabel() {
        const {
            product: { price_range, dynamic_price, type_id },
        } = this.props;

        const {
            price: {
                discount: { percentOff },
            },
        } = getPrice(price_range, dynamic_price, {}, type_id);

        return (
            <DiscountLabel value={roundPercentage(percentOff)} mix={{ block: 'ProductCard', elem: 'DiscountLabel' }} />
        );
    }

    renderContent = () => null;

    render() {
        const { isLoading, isRemoving } = this.props;
        const product = this.getWishlistProduct();

        if (!product) {
            return null;
        }

        return (
            <ProductCardWishlist
                product={product}
                isLoading={isLoading || isRemoving}
                mix={{ block: 'ProductCardWishlist' }}
                removeButton={this.renderRemove()}
            />
        );
    }
}

export default WishlistItem;
